export default "__VITE_ASSET__BLwkYaTF__"